import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { UsersListFilterKeys } from '../../model/types';
import { DisposalContentStatus } from 'entities/User';
import { MultipleSelect } from 'shared/ui/MultipleSelect';

interface DisposalContentStatusSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  onClear: (filterKey: string) => void;
}

export const DisposalContentStatusSelect: FC<DisposalContentStatusSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation(['contracts', 'user']);

  const disposalContentStatusOptions = useMemo<Array<{ label: string; value: DisposalContentStatus }>>(() => {
    return [
      { label: t('Without status', { ns: 'user' }), value: DisposalContentStatus.WITHOUT_STATUS },
      { label: t('disposed', { ns: 'user' }), value: DisposalContentStatus.DISPOSED },
      { label: t('empty', { ns: 'user' }), value: DisposalContentStatus.EMPTY },
    ];
  }, [t]);

  const clearFilter = useCallback(() => {
    onClear(UsersListFilterKeys.disposalContentStatus);
  }, [onClear]);

  const handleChange = useCallback(
    (value: string[]): void => {
      value.length ? onChange(value) : clearFilter();
    },
    [onChange, clearFilter],
  );

  return (
    <MultipleSelect
      containerClassName="flex-1"
      className="w-full"
      label={t('Disposal content status', { ns: 'user' })}
      placeholder={t('All')}
      bordered
      allowClear
      options={disposalContentStatusOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
